import { v4 as uuidv4 } from 'uuid'
import * as Sentry from '@sentry/browser'
import Cookies from 'js-cookie'

import {
  COOKIE_INTEGRATION_BW_CENTRAL,
  COOKIE_INTEGRATION_NAME,
  EXPIRE_DATE_TOKEN_NAME
} from 'modules/auth/auth.constants'

export const trace = {
  idKey: 'UNIQUE_ID',
  createId() {
    const ID = localStorage.getItem(this.idKey)

    if (!ID) {
      localStorage.setItem(this.idKey, uuidv4())
    }
  },
  trhowMsg(msg) {
    const THE_TOKEN = Cookies.get(COOKIE_INTEGRATION_BW_CENTRAL) || Cookies.get(COOKIE_INTEGRATION_NAME)
    const THE_DATE_EXPIRE = Cookies.get(EXPIRE_DATE_TOKEN_NAME)?.split('|')[0]

    Sentry.captureMessage(
      `${msg}, ${
        THE_DATE_EXPIRE
          ? `expired: ${Number(new Date().getTime()) > Number(THE_DATE_EXPIRE) * 1000}`
          : 'noExpiredAttribute'
      }, id: ${localStorage.getItem(this.idKey)}, token: ${encodeURIComponent(THE_TOKEN)}`,
      'debug'
    )
  }
}
